import API from 'services/API';

export const getCooperative = (id) => API.get(`/cooperatives/${id}`);

// TECHNICIAN

export const getAllTechnicianFull = (options = null) => {
  let queryParamsString = 'version=full';
  if (options && options.queryParamsString) {
    for (const [key, value] of Object.entries(options.queryParamsString)) {
      queryParamsString += '&' + key + '=' + value;
    }
  }
  return API.get('/users?' + queryParamsString);
};

export const addTechnician = (user) => API.post('/users/add', user);

export const updateTechnician = (user) => API.patch(`/users/edit/${user.id}`, user);

export const deleteTechnician = (user) => API.delete(`/users/remove/${user.id}`);

export const linkUserToSector = (user) => API.patch(`/users/edit/link_sector/${user.id}`, user);

// CULTURE
export const addCulture = (culture, cooperativeId = -1) =>
  API.post(
    cooperativeId > -1 ? `/cultures/add?cooperative=${cooperativeId}` : '/cultures/add',
    culture
  );

export const getCultures = (cooperativeId, organic, sort = 'name') =>
  API.get(`/cooperatives/${cooperativeId}/cultures`, {
    params: {
      organic,
      sort,
    },
  });

export const getCultureById = (id) => API.get(`/cultures/${id}`);

export const getMetacultureList = () => API.get(`/metacultures`);

export const updateCulture = (culture, id) => API.patch(`/cultures/edit/${id}`, culture);

export const deleteCulture = (culture) =>
  API.delete(`/cultures/remove/${culture.id}?safe-delete=true`);

export const resetCulture = (culture, organic) =>
  API.delete(`/cultures/reset/${culture.id}?organic=${organic}`);

// CULTURE GROUP
export const getCultureGroupList = (structureId) =>
  API.get(`/structure/${structureId}/cultures/mixed-farming-group`);

export const addCultureGroup = (structureId, culture) =>
  API.post(`/structure/${structureId}/cultures/mixed-farming-group`, culture);

export const updateCultureGroup = (structureId, cultureGroupId, culture) =>
  API.patch(`/structure/${structureId}/cultures/mixed-farming-group/${cultureGroupId}`, culture);

export const deleteCultureGroup = (structureId, cultureGroupId) =>
  API.delete(`/structure/${structureId}/cultures/mixed-farming-group/${cultureGroupId}`);

// NON RETURNCULTURE GROUP
export const getStructureNonReturnCultureGroupList = (structureId) =>
  API.get(`/structure/${structureId}/non-return-culture-group`);

export const addStructureNonReturnCultureGroup = (structureId, culture) =>
  API.post(`/structure/${structureId}/non-return-culture-group`, culture);

export const updateStructureNonReturnCultureGroup = (structureId, cultureGroupId, culture) =>
  API.patch(`/structure/${structureId}/non-return-culture-group/${cultureGroupId}`, culture);

export const deleteStructureNonReturnCultureGroup = (structureId, cultureGroup) =>
  API.delete(`/structure/${structureId}/non-return-culture-group`, {
    data: cultureGroup,
  });

// CONSTRAINTS
export const getConstraint = (id) => API.get(`/constraints/${id}`);

// CONSTRAINT CATEGORIES
export const getAllConstraintCategories = () => API.get(`/constraint_categories`);
export const getConstraintCategories = (cooperativeId) =>
  API.get(`/constraint_categories/${cooperativeId}`);
export const getCoProductsFromConstraintCategory = (data) =>
  API.post(`/constraint_categories/co-products`, data);

// CO PRODUCTS
export const getCoProducts = () => API.get(`/coproducts`);
export const getCoProductsPerCooperative = (cooperativeId) =>
  API.get(
    cooperativeId
      ? `/coproducts/cooperative?cooperativeId=${cooperativeId}`
      : `/coproducts/cooperative`
  );

export const renameCoProducts = (data) => API.patch(`/coproducts/rename/batch`, data);

export const linkCoProductToConstraint = (coProductId, constraintId) =>
  API.patch(`/coproducts/edit/${coProductId}/link_constraint/${constraintId}`);
export const associateCoProducts = (data) => API.post(`/coproducts/associate`, data);
export const newCategoryOrCoProduct = (data) => API.post(`/coproducts/new`, data);

// ROTATE EFFECTS

export const updateRotationEffect = (from, cooperativeId, body) =>
  API.patch(`/${from}/${cooperativeId}/rotation-effects`, {
    rotateEffectList: body,
  });

// SECTOR
export const addSecteur = (secteur, cooperativeId = -1) =>
  API.post(
    cooperativeId > -1 ? `/sectors/add?cooperative=${cooperativeId}` : '/sectors/add',
    secteur
  );

export const updateSecteur = (secteur) => API.patch(`/sectors/edit/${secteur.id}`, secteur);

export const deleteSector = (sectorId) => API.delete(`/sectors/remove/${sectorId}`);

export const getSecteurLight = (id) => API.get(`/sectors?version=light&cooperative=${id}`);

export const getSecteurList = (id) => API.get(`/sector-list/${id}`);

// GroundType
export const addGroundType = (groundType, cooperativeId = -1) =>
  API.post(
    cooperativeId > -1 ? `/ground-types/add?cooperative=${cooperativeId}` : '/ground-types/add',
    groundType
  );

export const updateGroundType = (groundType) =>
  API.patch(`/ground-types/edit/${groundType.id}`, groundType);

export const deleteGroundType = (groundType) => API.delete(`/ground-types/${groundType.id}`);

export const updateGroundTypeEffect = (from, ownerId, body) =>
  API.patch(`/${from}/${ownerId}/ground-type-effects`, {
    groundTypeEffectList: body,
  });

// Import CSV

export const importCsvData = (formdata, cooperativeId) =>
  API.post(`/exploitation/${cooperativeId}/importParcelsCsv`, formdata, {
    headers: { 'content-type': 'multipart/form-data' },
  });

// Import metaculture
export const importCsvDataMetaculture = (formdata) =>
  API.post(`/tools/import-cultures`, formdata, {
    headers: { 'content-type': 'multipart/form-data' },
  });

// Export metaculture
export const exportCsvDataMetaculture = () => API.get(`/tools/export-cultures`, {});

// Import Geofolia
export const importZipGeofolia = (formdata, cooperativeId) =>
  API.post(`/exploitation/${cooperativeId}/importParcelsGeofolia`, formdata, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const getGeofoliaPreflight = (jobId) => API.get(`/cache/geofolia/${jobId}`);

export const importParcelsGeofolia = (jobId, formdata) =>
  API.post(`/cache/geofolia/persist/${jobId}`, formdata);

// Import Wiuz
export const importWiuzExploitation = (id) => API.get(`/cooperative/${id}/importExploitations`);

export const getExploitationTypes = () => API.get(`/exploitations-types`);

export const importParcelsWiuz = (cooperativeId, data) =>
  API.post(`/exploitation/${cooperativeId}/importParcelsWiuz`, data);

// To check the status of the Wiuz importation
export const importParcelsResult = (jobId) => API.get(`exploitation/${jobId}/importParcelsResult`);

export const importParcelsStatus = (jobId) => API.get(`exploitation/${jobId}/importParcelsStatus`);

export const importMatchingParcels = (jobId) => API.get(`importMatchingParcels/${jobId}`);

export const importMatchingParcelsResult = (locale, jobId, data) =>
  API.post(`/${locale}/importMatchingParcels/${jobId}/persist`, data);

// MAPPING TYPES
export const getMappingFiles = (cooperativeId) =>
  API.get(`structure/${cooperativeId}/mappingTypes`);

// MAPPING CULTURE
export const getCultureMappingDataByTypeAndStructure = (mappingType, structureId) =>
  API.get(`/mapping/culture/${mappingType}/${structureId}`);

export const deleteCultureMappingData = (mappingType, structureId, dataToDelete) =>
  API.delete(`/mapping/culture/${mappingType}/${structureId}`, {
    data: dataToDelete,
  });

export const editCultureMappingData = (mappingType, structureId, data) =>
  API.patch(`/mapping/culture/${mappingType}/${structureId}`, data);

export const addCultureMappingData = (mappingType, structureId, data) =>
  API.post(`/mapping/culture/${mappingType}/${structureId}`, data);

// IMPORT MAPPING FILE CULTURE
export const importCultureMappingData = (mappingType, structureId, formData) =>
  API.post(`/mapping/culture/${mappingType}/${structureId}/import`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });

// IMPORT MAPPING FILE GROUND TYPE
export const importGroundTypeMappingData = (mappingType, structureId, formData) =>
  API.post(`/mapping/groundtype/${mappingType}/${structureId}/import`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });

// MAPPING GROUND TYPE
export const getGroundTypeMappingDataByTypeAndStructure = (mappingType, structureId) =>
  API.get(`/mapping/groundtype/${mappingType}/${structureId}`);

export const addGroundTypeMappingData = (mappingType, structureId, data) =>
  API.post(`/mapping/groundtype/${mappingType}/${structureId}`, data);

export const deleteGroundTypeMapping = (mappingType, structureId, dataToDelete) =>
  API.delete(`/mapping/groundtype/${mappingType}/${structureId}`, {
    data: dataToDelete,
  });

export const editGroundTypeMappingData = (mappingType, structureId, data) =>
  API.patch(`/mapping/groundtype/${mappingType}/${structureId}`, data);

export default {
  getCooperative,
  addTechnician,
  updateTechnician,
  deleteTechnician,
  addCulture,
  getCultureById,
  updateCulture,
  deleteCulture,
  addSecteur,
  updateSecteur,
  deleteSector,
  addGroundType,
  updateGroundType,
  deleteGroundType,
};
